module.exports = __webpack_public_path__ + "static/media/V86.f8291471.png";